import React from 'react';
import { Box, Button, Grid, InputLabel, OutlinedInput, Paper } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { useUnidEntityCreateController } from './context/unid-entity-create-controller';
import { useUnidEntityCreateState } from './context/unid-entity-create-context';
import PageHeader from '../../../components/page-header';

export function UnidEntityCreateComponent() {
    const {
        handleOnChange,
        handleSave
    } = useUnidEntityCreateController();

    const {
        request,
        showValidationErrors
    } = useUnidEntityCreateState();

    return (
        <React.Fragment>
            <Grid item xs={12} md={12} lg={12}>
                <PageHeader
                    title="Nova Unidade da Entidade"
                    subtitle="Cadastre uma nova unidade ou entidade no sistema"
                    breadcrumbs={[
                        { label: 'Unidades da Entidade', href: '/unidades-entidade' },
                        { label: 'Nova Uniddade da Entidade' }
                    ]}
                />
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <Paper
                    sx={{
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                    elevation={3}
                >
                    <Grid container spacing={2}>
                        <Grid item lg={2} sm={2} xl={2}>
                            <InputLabel required>Código Unidade</InputLabel>
                            <OutlinedInput
                                name="input-unit-code"
                                fullWidth
                                error={showValidationErrors && (!request.unitCode || request.unitCode.length === 0)}
                                value={request.unitCode || ''}
                                onChange={handleOnChange}
                                required
                            />
                        </Grid>
                        <Grid item lg={12} sm={12} xl={12}>
                            <InputLabel required>Nome</InputLabel>
                            <OutlinedInput
                                name="input-name"
                                fullWidth
                                error={showValidationErrors && (!request.name || request.name.length === 0)}
                                value={request.name || ''}
                                onChange={handleOnChange}
                                required
                            />
                        </Grid>
                        <Grid item lg={2} sm={2} xl={2}>
                            <InputLabel required>Código IBGE</InputLabel>
                            <OutlinedInput
                                name="input-ibge-code"
                                fullWidth
                                error={showValidationErrors && (!request.ibgeCode || request.ibgeCode.length === 0)}
                                value={request.ibgeCode || ''}
                                onChange={handleOnChange}
                                required
                            />
                        </Grid>
                        <Grid item lg={12} sm={12} xl={12}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                <Box sx={{ flex: '1 1 auto' }} />
                                <Button
                                    variant="contained"
                                    onClick={handleSave}
                                    endIcon={<SaveIcon />}
                                >
                                    Salvar
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
